module.exports = __webpack_public_path__ + "static/payment_gateway-81aa9209c5f3f0c06ea8978c3ca5414e.svg";